<template>
  <RouterView />
</template>

<script setup>
import useBlankDashboardFix from '@/composables/useBlankDashboardFix'
useBlankDashboardFix()
</script>

<script>
export default {
  name: 'IndividualRouter'
}
</script>

<style lang="scss" scoped></style>
